<i18n src="./resources/locales.json"></i18n>

<template>
  <v-card color="surface lighten-1" elevation="3" class="metrics-container">
    <div ref="chart" class="surface graph" />

    <div class="details">
      <div v-once class="graph-type">{{ $t('graph.details.graph_type') }}</div>
      <div v-once class="graph-title">{{ $t('graph.details.graph_title') }}</div>
      <div v-once class="graph-description">
        {{ $t('graph.details.graph_description') }}
      </div>
      <div class="graph-legend">
        <div class="item">
          <div class="color a" />
          <div v-once class="description">
            {{ $t('graph.details.graph_legend.your_performance') }}
          </div>
        </div>
        <div class="clear" />
        <div class="item">
          <div class="color b" />
          <div v-once class="description">
            {{ $t('graph.details.graph_legend.average_performance') }}
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <v-btn text class="secondary dismiss" role="button">
        <span v-once>{{ $t('graph.actions.dismiss') }}</span>
      </v-btn>
      <div class="clear" />
    </div>
  </v-card>
</template>

<script>
import * as d3 from 'd3';
import AreaChart from '@/components/ecs-agent-metrics-card/ecs-agent-metrics-area-chart';
import BarChart from '@/components/ecs-agent-metrics-card/ecs-agent-metrics-bar-chart';

export default {
  name: 'EcsAgentMetricsCard',

  props: {
    dataset: {
      type: Array,
      default() {
        return [];
      }
    },
    graphType: {
      type: String,
      default: 'area'
    }
  },

  data() {
    return {};
  },

  created() {
    this.initialize();
  },

  mounted() {
    switch (this.graphType) {
      case 'area':
        // eslint-disable-next-line no-new
        new AreaChart(
          d3,
          this.$refs.chart,
          this.dataset,
          this.$t('graph.details.graph_legend.your_performance'),
          this.$t('graph.details.graph_legend.average_performance')
        );
        break;
      case 'bar':
        // eslint-disable-next-line no-new
        new BarChart(
          d3,
          this.$refs.chart,
          this.dataset,
          {
            lbl: this.$t('graph.details.graph_legend.your_performance'),
            color: 'var(--v-primary-base)'
          },
          {
            lbl: this.$t('graph.details.graph_legend.average_performance'),
            color: 'var(--v-warning-base)'
          }
        );
        break;
      default:
        break;
    }
  },

  methods: {
    initialize() {}
  }
};
</script>

<style>
.graph-tooltip {
  position: absolute;
  font-size: 12px;
  top: 12px;
  left: 12px;
  fill: none;
  border: 1px solid var(--v-surface-lighten2);
  border-radius: 4px;
  padding: 8px 12px;
  background-color: var(--v-surface-lighten1);
  pointer-events: none;
}
.graph-tooltip .graph-tooltip-primary {
  color: var(--v-warning-lighten1);
}
.graph-tooltip .graph-tooltip-secondary {
  color: var(--v-primary-lighten1);
}
.graph-dot {
  fill: var(--v-warning-base);
  stroke: var(--v-warning-darken2);
  stroke-width: 1px;
  transition: all ease 0.2s;
}
.graph-dot:hover {
  r: 8;
}
.graph-primary-area {
  stroke: var(--v-warning-base);
  stroke-width: 1px;
  fill: var(--v-warning-lighten2);
  opacity: 0.9;
}
.graph-secondary-area {
  stroke: var(--v-primary-base);
  stroke-width: 1px;
  fill: var(--v-primary-lighten2);
}

.graph-axis {
  opacity: 0.9;
}

.graph-axis .tick line {
  stroke: var(--v-border-color);
  stroke-width: 0.5px;
}

[dark] .graph-axis .tick line {
  stroke: var(--v-surface-lighten2);
}

.graph-group {
  transition: all ease 0.2s;
}

.graph-group:hover {
  stroke-width: 2px;
  stroke: #fff9;
}
</style>

<style scoped>
.graph {
  border-bottom: 1px solid var(--v-primary-base) !important;
}
.metrics-container {
  width: 400px;
  min-height: 400px;
  overflow: hidden;
  float: left;
  position: relative;
}

.metrics-container .clear {
  clear: both;
}

.metrics-container .graph {
  height: 200px;
}
.metrics-container .details {
  padding: 16px;
}
.metrics-container .details .graph-type {
  text-transform: uppercase;
}
.metrics-container .details .graph-title {
  font-size: 22px;
}
.metrics-container .details .graph-description {
  padding: 12px 0;
}

.metrics-container .details .graph-legend .item {
  height: 30px;
  line-height: 30px;
}
.metrics-container .details .graph-legend .item .color {
  width: 60px;
  height: 20px;
  float: left;
  margin: 4px 0;
}
.metrics-container .details .graph-legend .item .color.a {
  background-color: var(--v-warning-base);
}
.metrics-container .details .graph-legend .item .color.b {
  background-color: var(--v-primary-base);
}
.metrics-container .details .graph-legend .item .description {
  height: 20px;
  line-height: 20px;
  padding-left: 16px;
  display: inline-block;
}
.metrics-container .actions {
  padding: 8px;
}
.metrics-container .actions .dismiss {
  float: right;
}
</style>
